import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Shop from './pages/Shop';
import Checkout from './pages/Checkout';
import PaymentSuccess from './pages/PaymentSuccess';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/"                element={<Home />} />
        <Route path="/services"        element={<Services />} />
        <Route path="/shop"            element={<Shop />} />
        <Route path="/contact"         element={<Contact />} />
        <Route path="/checkout"        element={<Checkout />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
